import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaArrowRight, FaTimes } from "react-icons/fa";
import { OFFERS_DATA } from "../../constant/OffersData";

const isOfferActive = (offer) => {
  const today = new Date().toISOString().slice(0, 10);
  return today >= offer.validFrom && today <= offer.validTo;
};

const DISMISS_KEY = "dismissedOfferIds";

const getDismissedIds = () => {
  try {
    return JSON.parse(localStorage.getItem(DISMISS_KEY) || "[]");
  } catch {
    return [];
  }
};

const HomeOffers = () => {
  const navigate = useNavigate();
  const [dismissedIds, setDismissedIds] = useState(getDismissedIds);
  const [index, setIndex] = useState(0);

  const activeOffers = OFFERS_DATA.filter(
    (offer) => isOfferActive(offer) && !dismissedIds.includes(offer.id)
  );

  useEffect(() => {
    if (activeOffers.length < 2) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % activeOffers.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [activeOffers.length]);

  if (activeOffers.length === 0) return null;

  const offer = activeOffers[index % activeOffers.length];

  const dismiss = () => {
    const next = [...dismissedIds, offer.id];
    localStorage.setItem(DISMISS_KEY, JSON.stringify(next));
    setDismissedIds(next);
  };

  return (
    <div className="relative border-b border-white/10 bg-[var(--website-primary-color)] px-4 py-3 text-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-2 text-center sm:flex-row sm:gap-4 sm:pr-8">
        <p className="text-sm font-medium leading-snug sm:text-base">
          {offer.emoji && <span className="mr-2">{offer.emoji}</span>}
          {offer.message}{" "}
          <Link to="/offers" className="underline decoration-white/40 underline-offset-2 hover:decoration-white">
            View all offers
          </Link>
        </p>
        <button
          onClick={() => navigate(offer.ctaLink || "/contact")}
          className="inline-flex flex-shrink-0 items-center gap-1.5 rounded-full bg-[var(--website-secondary-color)] px-4 py-1.5 text-xs font-semibold text-[var(--on-secondary)] transition hover:brightness-110 sm:text-sm"
        >
          {offer.ctaText || "Get in touch"}
          <FaArrowRight size={10} />
        </button>
      </div>
      <button
        onClick={dismiss}
        aria-label="Dismiss offer"
        className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full p-1.5 text-white/60 transition hover:bg-white/10 hover:text-white"
      >
        <FaTimes size={13} />
      </button>
      {offer.accentStripe && (
        <div className="absolute inset-x-0 bottom-0 h-[3px] bg-gradient-to-r from-[#FF9933] via-white to-[#138808]" />
      )}
    </div>
  );
};

export default HomeOffers;
